import React from 'react';

import {
  Card,
  Category,
  Title,
  AttributesWrapper,
  LinkIconContainer,
  ArrowWrapper
} from './StyledSecondaryCard';
import NavLink from '../NavItem';
import ContentTypeAttributes from '_utils/components/Corporate/ContentTypeAttributes';
import { getContentType } from '_utils/helpers/contentType';
import Arrow from '_utils/icons/Arrow';
import External from '_utils/icons/External';
import { getLink, isValidLinkObject } from '_utils/helpers/link';
import { TitleIconWrapper } from './StyledFeaturedContent';
import PropTypes from 'prop-types';

function SecondaryCard({ title, description, link, attributes, primaryCategory, type }) {
  let contentType = getContentType(type);

  const linkObject = getLink(link);

  return (
    <NavLink StyledLink={Card} link={linkObject} description={description}>
      {primaryCategory && <Category>{primaryCategory}</Category>}
      {title && (
        <LinkIconContainer>
          <Title>
            {title}
            {isValidLinkObject(linkObject) && (
              <TitleIconWrapper>
                &#65279;
                <ArrowWrapper>
                  {linkObject.type !== 'external' && <Arrow ariaHidden={true} />}
                  {linkObject.type === 'external' && <External ariaHidden={true} />}
                </ArrowWrapper>
              </TitleIconWrapper>
            )}
          </Title>
        </LinkIconContainer>
      )}

      <ContentTypeAttributes
        attributes={attributes}
        contentType={contentType}
        Wrapper={AttributesWrapper}
      />
    </NavLink>
  );
}

SecondaryCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.object,
  attributes: PropTypes.array,
  primaryCategory: PropTypes.string,
  type: PropTypes.string
};

export default SecondaryCard;
